import DFile from "../classes/DFile";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class LeadImportFile extends DBObject {
  private static readonly _FILE: number = 0;
  public id: number = 0;
  public otherMaster: DBObject;
  private _file: DFile = null;
  public constructor(d3eParams?: Partial<{ file: DFile }>) {
    super();

    this.setFile(d3eParams?.file ?? null);
  }
  public get d3eType(): string {
    return "LeadImportFile";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get isTransientModel(): boolean {
    return;
  }
  public get file(): DFile {
    return this._file;
  }
  public setFile(val: DFile): void {
    let isValChanged: boolean = this._file !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(LeadImportFile._FILE, this._file);

    this._file = val;

    this.fire("file", this);
  }
  public get(field: number): any {
    switch (field) {
      case LeadImportFile._FILE: {
        return this._file;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): LeadImportFile {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: LeadImportFile = dbObj as LeadImportFile;

    obj.id = this.id;

    obj.setFile(this._file);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case LeadImportFile._FILE: {
        this.setFile(value as DFile);
        break;
      }
    }
  }
}
